import type { Schema } from '../../../Entities/Schema.entity';
import { createSchema } from '../../../Utils/CreateSchema';

export const createAlertEmailConfirmationSchema: Schema = {
  ...createSchema({
    version: '1-0-0',
    description: 'When the user has been redirected to the email confirmation screen',
    name: 'create_alert_email_confirmation',
    properties: {},
  }),
};
